@if (data$ | async; as data) {
  <div class="container">
    @if (data.rootCategoryCode) {
      <h3>{{ data.title }}</h3>
      @if (getCategoryHierarchy(data.rootCategoryCode) | async; as hierarchy) {
        <div
          class="sub-categories-wrapper"
          >
          <div class="sub-categories">
            <aimo-category-header-subcategory
                [categoryId]="hierarchy.id"
                [showAll]="true" [values]="hierarchy.subcategories">
            </aimo-category-header-subcategory>
          </div>
        </div>
      } @else {
        <aimo-spinner></aimo-spinner>
      }
    }
  </div>
} @else {
  <aimo-spinner></aimo-spinner>
}

